export default __webpack_public_path__ + "static/media/profile-user.f6983d15.svg";